"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EllipsisButton = exports.StyledBreadcrumbs = exports.classes = void 0;
const Breadcrumbs_1 = __importDefault(require("@mui/material/Breadcrumbs"));
const styles_1 = require("@mui/material/styles");
const button_1 = __importStar(require("../button"));
const PREFIX = "Breadcrumbs";
exports.classes = {
    separator: `${PREFIX}-separator`,
    darkThemed: `${PREFIX}-darkThemed`,
    link: `${PREFIX}-link`,
    label: `${PREFIX}-label`,
    startIcon: `${PREFIX}-startIcon`,
    lastBreadcrumb: `${PREFIX}-lastBreadcrumb`
};
exports.StyledBreadcrumbs = (0, styles_1.styled)(Breadcrumbs_1.default)(({ theme: { colours, breakpoints } }) => ({
    [`& .${exports.classes.separator}`]: {
        margin: "0",
        width: "8px"
    },
    [`& .${exports.classes.link}`]: {
        padding: "0 6px",
        minWidth: "auto",
        height: "42px"
    },
    [`& .${exports.classes.lastBreadcrumb}`]: {
        padding: "0 6px",
        color: colours.slate
    },
    [`.${button_1.buttonClasses.startIcon}`]: {
        fontSize: "inherit",
        [`${breakpoints.up("sm")}`]: {
            display: "none"
        }
    },
    [`&.${exports.classes.darkThemed}`]: {
        color: colours.storm,
        [`& .${exports.classes.link}`]: {
            textDecoration: "underline",
            textDecorationColor: colours.storm
        },
        [`& .${exports.classes.lastBreadcrumb}`]: {
            color: colours.storm
        },
        [`& .${exports.classes.label}`]: {
            maxWidth: "none"
        }
    }
}));
exports.EllipsisButton = (0, styles_1.styled)(button_1.default)(() => ({
    minWidth: "42px",
    minHeight: "42px"
}));
//# sourceMappingURL=data:application/json;base64,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